import React, { useState } from 'react';
import { X } from 'lucide-react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    {
      id: 1,
      src: '/images/gallery1.jpeg',
      title: 'Career Counseling Session',
      description: 'Students receiving career guidance',
    },
    {
      id: 2,
      src: '/images/gallery2.jpeg',
      title: 'Workshop Program',
      description: 'Skill development workshop',
    },
    {
      id: 3,
      src: '/images/gallery3.jpeg',
      title: 'Women Empowerment',
      description: 'Women empowerment program',
    },
    {
      id: 4,
      src: '/images/gallery4.jpeg',
      title: 'Student Counseling',
      description: 'One-on-one student counseling',
    },
    {
      id: 5,
      src: '/images/gallery5.jpeg',
      title: 'Community Awareness',
      description: 'Community awareness campaign',
    },
    {
      id: 6,
      src: '/images/gallery6.jpeg',
      title: 'Educational Program',
      description: 'Educational awareness program',
    },
  ];

  return (
    <div className="min-h-screen">
      {/* Header Section */}
      <section className="gradient-bg text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Gallery</h1>
          <p className="text-xl hindi-text">गैलरी</p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="section-padding">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Work in Action</h2>
            <p className="text-xl text-gray-600 hindi-text">हमारे कार्य की झलकियां</p>
          </div>

          <div className="gallery-grid">
            {images.map((image) => (
              <div
                key={image.id}
                className="gallery-item"
                onClick={() => setSelectedImage(image)}
              >
                <img src={image.src} alt={image.title} />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                  <h3 className="text-white font-bold text-lg">{image.title}</h3>
                  <p className="text-gray-200 text-sm">{image.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 bg-white text-gray-800 p-2 rounded-full hover:bg-gray-200 transition-colors z-10"
            >
              <X size={24} />
            </button>
            <img
              src={selectedImage.src}
              alt={selectedImage.title}
              className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
            />
            <div className="bg-white p-6 rounded-b-lg">
              <h3 className="text-2xl font-bold text-gray-800 mb-2">{selectedImage.title}</h3>
              <p className="text-gray-600">{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
